require('./contractAresLoanView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require("react-router-dom");
const Inmutable = require('immutable');
// @core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @common
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @components
const ContractAresLoan = require('../../components/contracts/contractAresLoan/contractAresLoan');
// @constants
const { NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES } = require('constants/flagBasedFeatures');
const translations = require('./contractAresLoanView.translations');
const dossierStatus = require('../../loansConstants/dossierStatus');
const paymentDayType = require('../../loansConstants/paymentDayType');
const translationsStep2 = require('../../components/contracts/contractAresLoan/contractAresLoanStep2/contractAresLoanStep2.translations');
// @actions
const aresDossierActions = require('../../actions/aresDossier');
const { getBlockedAccounts } = require('actions/blockedAccounts');
// @utilities
const { recordLinkV2, recordPath, PAGE_GENERIC, PAGE_CONTRACT_ARES_LOAN_STEP2 } = require('utilities/tagging');
const { buildContractAresLoanPaymentDayType, buildContractAresLoanSelectAccount, getFirstFilteredAccountIndexThatIsnotBlocked } = require('../../loansUtilities/loansHelper');
const { mapFinalizationRequest } = require('../../components/contracts/contractAresLoan/contractAresLoanHelper');
//@analytics
const { catalogue, analyticsId } = require( '../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics' );

class ContractAresLoanView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            immSteps: Inmutable.fromJS([ { valid: true }, { valid: false, hasSignaturePattern: true } ]),
            visibleStep: 1,
            selectedAccountId: null,
            selectedAccount: null,
            paymentDayType: paymentDayType.ANNIVERSARY,
        };

        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.setSelectedAccount = this.setSelectedAccount.bind(this);
        this.setPaymentDateType = this.setPaymentDateType.bind(this);
        this.handleFinishWizard = this.handleFinishWizard.bind(this);
        this.cancelDossier = this.cancelDossier.bind(this);

    }

    componentDidMount() {
        const { immFlagBasedFeatures, immAresDossier, retrieveAresDossier } = this.props;

        if (!immFlagBasedFeatures.get(NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES)) {
            this.props.history.push('/myprofile/global');
            return;
        }

        if (!immAresDossier.get('dossier')) {
            retrieveAresDossier();
        } else {
            this.updateInfo(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immAresDossier } = nextProps;
        if (!immAresDossier.get('isFetching') && immAresDossier.get('success')) {
            const dossier = immAresDossier.get('dossier');
            if (!dossier ||
                (dossier.get('status') !== dossierStatus.APPROVED && dossier.get('status') !== dossierStatus.M2_COUNTEROFFER && immAresDossier.get('dossier').get('status') !== dossierStatus.LOAN_COMPLETE)
                ) {
                this.props.history.push('/myprofile/global');
            }

            if (dossier && (dossier.get('status') === dossierStatus.APPROVED || dossier.get('status') === dossierStatus.M2_COUNTEROFFER || immAresDossier.get('dossier').get('status') === dossierStatus.LOAN_COMPLETE)) {
                this.updateInfo(nextProps);
            }
        }
    }

    updateInfo(nextProps) {
        const { immAresDossier, immAccounts } = nextProps;
        const dossier = immAresDossier.get('dossier');
        this.setState({
            paymentDayType:
                (dossier && dossier.get('contractingData') && dossier.get('contractingData').get('paymentDayType'))
                || paymentDayType.ANNIVERSARY
        });
        // select account
        const nonBlockedAccounts =
            (dossier && dossier.get('contractingData') && dossier.get('contractingData').get('accountData') && dossier.get('contractingData').get('accountData').get('accountId'))
            || getFirstFilteredAccountIndexThatIsnotBlocked(immAccounts);
        this.setSelectedAccount(nonBlockedAccounts);
    }

    setVisibleStep(visibleStep) {
        this.setState({ visibleStep });
    }

    handleFinishWizard() {
        const { aresFinalization, immAresDossier } = this.props;
        const { paymentDayType, selectedAccount } = this.state;
        const acceptedText = formatText(translationsStep2.PDF_VIEWER_CHECKBOX);
        aresFinalization(mapFinalizationRequest(immAresDossier.get('dossier'), selectedAccount, paymentDayType, acceptedText));
    }

    validateStep() {
        const { visibleStep, paymentDayType, selectedAccount } = this.state;
        const { immAresDossier, validateSignature } = this.props;
        const contractingData = immAresDossier.get('dossier').get('contractingData');

        if (visibleStep === 1) { // STEP 1
            this.props.registerProposal(contractingData, paymentDayType, selectedAccount)
                .then(() => {
                    this.setState({ visibleStep: visibleStep + 1 });
                    recordPath(PAGE_CONTRACT_ARES_LOAN_STEP2, PAGE_GENERIC, 'contratacion-prestamo-ares', 'paso_2');
                });
        } else { // STEP 2
            validateSignature(() => this.handleFinishWizard());
        }
    }

    setSelectedAccount(selectedAccountId) {
        const { immAccounts } = this.props;
        const selectedAccount = immAccounts.getIn(['byId', selectedAccountId]);
        this.setState({ selectedAccountId, selectedAccount });

        recordLinkV2(buildContractAresLoanSelectAccount());
    }

    setPaymentDateType(paymentDayType) {
        this.setState({ paymentDayType });
        recordLinkV2(buildContractAresLoanPaymentDayType(paymentDayType));
    }

    cancelDossier() {
        this.props.cancelAresDossier()
            .then(() => this.props.history.push('/myprofile/global'));
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText(translations.BREADCRUMB_01),
                url: '/myprofile/loans-mortgages',
                onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
            },
            {
                text: formatText(translations.BREADCRUMB_02),
            }
        ];
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();

        return (
            <OKCover
                size="medium"
                section="generic"
                customClass="contract-ares-loan-view__header"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={getFinalTitle(translations.HEADER_TITLE)}
                />
            </OKCover>
        );
    }

    buildContent() {
        const { immSteps, visibleStep, selectedAccountId, selectedAccount, paymentDayType } = this.state;
        const { immFlagBasedFeatures, immAresDossier, immAccounts, getBlockedAccounts, immProfile } = this.props;
        return (
            <ContractAresLoan
                // FF
                immFlagBasedFeatures={immFlagBasedFeatures}
                // dossier
                immAresDossier={immAresDossier}
                cancelDossier={this.cancelDossier}
                // paymentDayType
                paymentDayType={paymentDayType}
                setPaymentDateType={this.setPaymentDateType}
                // accounts
                selectedAccountId={selectedAccountId}
                selectedAccount={selectedAccount}
                setSelectedAccount={this.setSelectedAccount}
                immAccounts={immAccounts}
                getBlockedAccounts={getBlockedAccounts}
                // steps
                immSteps={immSteps}
                visibleStep={visibleStep}
                setVisibleStep={this.setVisibleStep}
                validateStep={this.validateStep}
                immProfile={immProfile}
            />
        )
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <article className="contract-ares-loan-view">
                {header}
                <section className="contract-ares-loan-view__body row">
                    {content}
                </section>
            </article>
        );
    }
}

ContractAresLoanView.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    // dossiers
    immAresDossier: PropTypes.object,
    retrieveAresDossier: PropTypes.func.isRequired,
    cancelAresDossier: PropTypes.func.isRequired,
    registerProposal: PropTypes.func.isRequired,
    aresFinalization: PropTypes.func.isRequired,
    // signatura
    validateSignature: PropTypes.func.isRequired,
    // accounts
    immAccounts: PropTypes.object,
    getBlockedAccounts: PropTypes.func.isRequired,
    // profile
    immProfile: PropTypes.object.isRequited,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
    immAresDossier: state.aresDossier,
    immAccounts: state.accounts,
    immProfile: state.profile,
}),
{
    retrieveAresDossier: aresDossierActions.retrieveAresDossier,
    cancelAresDossier: aresDossierActions.cancelDossier,
    registerProposal: aresDossierActions.registerProposal,
    aresFinalization: aresDossierActions.aresFinalization,
    validateSignature: aresDossierActions.validateSignature,
    getBlockedAccounts: getBlockedAccounts,
})(ContractAresLoanView));
